const key = 'adobeDataLayer';
const publicUrl = new URL(process.env.PUBLIC_URL!, window.location.toString());

export function pushImpressionEvent(bannerIndex: number, banners: any[]): void {
    window[key] = window[key] || [];
    const component = banners[bannerIndex];

    window[key].push({
        event: 'componentImpression',
        componentInfo: {
            componentName: "carousel_hero",
            componentType: "carousel",
            componentBannerName: component.name,
            componentBannerLink: publicUrl.origin + component.link,
            componentBannerId: component.id,
        }
    });
}

export function pushClickEvent(componentName: string, linkPath: string, id: number): void {
        window[key] = window[key] || [];

        window[key].push({
            event: 'componentClick',
            componentInfo: {
                componentName: "carousel_hero",
                componentType: "carousel",
                componentBannerName: componentName,
                componentBannerLink: publicUrl.origin + linkPath,
                componentBannerId: id,
            }
        });
}
